import { topbar, header, buttonsFixed } from '@ui/theme/values'
import { useWindowDimensions } from 'react-native'
import { Easing, WithTimingConfig } from 'react-native-reanimated'

export const useHeightContainer = () => {
  const screen = useWindowDimensions()
  const top = topbar.height + header.height
  const height = screen.height - (top + buttonsFixed.height)
  const move = height + buttonsFixed.height

  return {
    top,
    move,
    height,
  }
}

export const timingConfig = {
  duration: 600,
  easing: Easing.out(Easing.bezierFn(0.75, 0, 0.5, 0.25)),
} satisfies WithTimingConfig
